import React from 'react';

import { Box } from '@/shared/ui';

import Typography from '@/shared/ui/typography/Text';

const Heading = ({ title, subtitle }: { title: string; subtitle: string }) => {
  return (
    <Box>
      <Typography
        size={24}
        sx={{ fontWeight: 'bold' }}
      >
        {title}
      </Typography>
      <Typography
        color='gx.subtext'
        size={14}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Heading;
